export const stripFileExtension = (filename) => {
  if (!filename) return filename;
  return filename.replace(/\.[^./]+$/, '');
};

export const formatPhoneNumber = (value) => {
  const cleaned = (value ?? '').replace(/\D/g, '').slice(0, 10);
  const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

  if (!match) return cleaned;

  let formatted = '';
  if (match[1]) formatted += match[1];
  if (match[2]) formatted += `-${match[2]}`;
  if (match[3]) formatted += `-${match[3]}`;

  return formatted;
};